import { LineHeightTokenValue } from 'designSystem/types';
import * as S from './styles';

interface LineHeightTokenPreviewProps {
	value: LineHeightTokenValue;
}

export const LineHeightTokenPreview = ({ value }: LineHeightTokenPreviewProps) => {
	const lineHeight = value.numeric || (value.length ? value.length.numericValue : 1.5);
	return (
		<S.PreviewContainer>
			<S.LineHeightSample lineHeight={lineHeight}>
				<div>Line one</div>
				<div>Line two</div>
				<div>Line three</div>
			</S.LineHeightSample>
			<S.ValueText>{value.original}</S.ValueText>
		</S.PreviewContainer>
	);
};
